import { app } from '@store/modules/app';
import { includesRequiredQueryParams } from '@src/utils/request';
import { microFeedbackData } from '@constants';
import { MicroFeedbackType } from 'types/micro-feedback';
import { RouteConfig } from 'vue-router';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const microFeedbackRoutes: Array<RouteConfig> = [
	{
		path: '/micro-feedback',
		name: 'micro-feedback',
		beforeEnter: async (to, from, next) => {
			const includesRequiredParams = includesRequiredQueryParams(['eventType'], to);
			if (includesRequiredParams) {
				next();
			} else {
				next({ name: 'account-overview', replace: true });
			}
		},
		component: () => import(/* webpackChunkName: "micro-feedback" */ '@views/micro-feedback/micro-feedback.vue'),
		redirect: { name: 'micro-feedback-satisfaction-form' },
		children: [
			{
				path: 'submit',
				name: 'micro-feedback-submit',
				component: () =>
					import(
						/* webpackChunkName: "micro-feedback-form-view" */ '@src/views/micro-feedback/micro-feedback-form-view.vue'
					)
			},
			{
				path: 'satisfaction-feedback',
				name: 'micro-feedback-satisfaction-form',
				component: () =>
					import(
						/* webpackChunkName: "micro-feedback-satisfaction-form" */ '@views/micro-feedback/micro-feedback-satisfaction-form.vue'
					)
			},
			{
				path: 'success',
				name: 'micro-feedback-success',
				component: () =>
					import(
						/* webpackChunkName: "micro-feedback-success" */ '@views/micro-feedback/micro-feedback-success.vue'
					)
			}
		]
	},
	{
		path: '/account/micro-feedback',
		name: 'micro-feedback-old',
		beforeEnter: async (to, from, next) => {
			next({ name: 'micro-feedback-submit', replace: true, query: to.query });
		}
	},
	{
		path: '/account/micro-feedback/redirect',
		name: 'micro-feedback-redirect',
		beforeEnter: async (to, from, next) => {
			const eventType = to.query.eventType as MicroFeedbackType;
			if (eventType) {
				next({ name: microFeedbackData[eventType].redirectRoute, replace: true });
				app.ADD_TOAST({
					type: 'success',
					message: 'Thanks for sharing your feedback.'
				});
			} else {
				next({ name: 'account-overview', replace: true });
				app.ADD_TOAST({
					type: 'success',
					message: 'Thanks for sharing your feedback.'
				});
			}
		}
	}
];
export default microFeedbackRoutes;
